import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import crochet1 from '../images/crochet1.jpg';
import crochet2 from '../images/crochet2.jpg';
import crochet3 from '../images/crochet3.jpg';
import crochet4 from '../images/crochet4.jpg';

// Keyframe for fade effect
const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.97); }
  to { opacity: 1; transform: scale(1); }
`;

const CarouselSection = styled.section`
  max-width: 960px;
  margin: 3rem auto;
  position: relative;
  overflow: hidden;
  border-radius: 1rem;
  box-shadow: 0 20px 50px rgba(122, 73, 136, 0.25);
  background: linear-gradient(to right, #FFF0F6, #FCE4EC);
`;

const CarouselContainer = styled.div`
  display: flex;
  transition: transform 0.6s ease-in-out;
  transform: translateX(${props => `-${props.currentSlide * 100}%`});
`;

const Slide = styled.div`
  min-width: 100%;
  height: 550px;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 0.8s ease-in-out;
`;

const SlideImage = styled.img`
  max-width: 90%;
  max-height: 90%;
  object-fit: cover;
  border-radius: 1rem;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  transition: transform 0.4s ease;

  &:hover {
    transform: scale(1.03);
  }
`;

const Arrow = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  color: #7A4988;
  font-size: 1.8rem;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  cursor: pointer;

  &:hover {
    background: #FFAAD7;
    color: white;
    transform: translateY(-50%) scale(1.1);
  }

  ${props => props.left ? `left: 1rem;` : `right: 1rem;`}
`;

const DotsWrapper = styled.div`
  position: absolute;
  bottom: 1.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 0.6rem;
`;

const Dot = styled.button`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background: ${props => props.active ? '#FF85C0' : '#ddd'};
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  transition: all 0.3s ease;

  &:hover {
    background: #7A4988;
  }
`;

const Carousel = () => {
  const slides = [crochet1, crochet2, crochet3, crochet4];
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <CarouselSection>
      <Arrow left onClick={prevSlide}>&lt;</Arrow>
      <CarouselContainer currentSlide={currentSlide}>
        {slides.map((img, index) => (
          <Slide key={index}>
            <SlideImage src={img} alt={`Slide ${index + 1}`} />
          </Slide>
        ))}
      </CarouselContainer>
      <Arrow onClick={nextSlide}>&gt;</Arrow>

      <DotsWrapper>
        {slides.map((_, index) => (
          <Dot
            key={index}
            active={index === currentSlide}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </DotsWrapper>
    </CarouselSection>
  );
};

export default Carousel;
